import type { Runtime } from "../../components/common/runtime";

export default function Login({ runtime, navigate }: { runtime: Runtime; navigate: (path: string) => void }) {
  const { t } = runtime.i18n;
  return <main id="view" className="page login-page"><form className="card login-card" onSubmit={event => {
    event.preventDefault(); runtime.ui.showToast(t("toast.loginOk")); navigate("/");
  }}>
    <img src="/seabird-logo.svg" alt="SeaBird" /><p className="lead">{t("login.title")}</p>
    <label htmlFor="email">{t("login.email")}</label><input id="email" type="email" defaultValue="contact@seabirdconseil.com" autoComplete="username" />
    <label htmlFor="password">{t("login.password")}</label><input id="password" type="password" autoComplete="current-password" />
    <button className="btn dark" type="submit">{t("login.submit")}</button>
  </form></main>;
}
